import request from './request';

export default {
	async getWebFormConfig() {
		const res = await request.get('/app/web-form');
		return res;
	},
	async getIncidentTypes() {
		const res = await request.get('/app/web-form/incident-types');
		return res;
	},
	async getCategories() {
		const res = await request.get('/app/web-form/categories');
		return res;
	},
	async createWebForm(body) {
		const res = await request.post('/app/web-form', body);
		return res;
	}
};
